import React, { useState, useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
// own components
import MenuMain from 'components/navbar/HeaderDefault.js';
import Footer from 'components/footer/FooterDefault.js';
import Cookies from 'components/cookiesAlert/cookies.js';

const DefaultLayout = (props) => {
  const location = useLocation()
  const [isDesktop, setIsDesktop] = useState(true);

  useEffect(() => {
    const getDevice = () => setIsDesktop(window.innerWidth > 991);

    getDevice();

    window.addEventListener('resize', getDevice);

    return () => {
      window.removeEventListener('resize', getDevice);
    };
  }, []);

  return (
    <>
      <MenuMain isDesktop={isDesktop} />
      <Cookies />
      <main className={location.pathname.includes('/mapa') ? "margin-md mt-3" : "margin-md mt-3 mainDiv"}>
        <Outlet />
      </main>
      <Footer />
    </>
  );
};

export default DefaultLayout;
